import React from 'react'

//* Components
import Banner from './components/Banner/Banner';
import Section2 from './components/Section2/Section2';
import Section3 from './components/Section3/Section3';

const FindYourPhone = () => {
  return (
    <div className="page">
      <Banner/>
      <Section2/>
      <Section3/>
    </div>
  )
}

export default FindYourPhone